import { Component } from 'react';
import NavigationTabLinks from '../containers/navigationTabLinks';
import {WebCache} from "../../services/WebCache";
import {ReactComponent as TransactionReportSVG} from "itd-common/assets/icons/receipt_long.svg";
import {ReactComponent as PendingOrdersSVG} from "itd-common/assets/icons/access_time.svg";
import "../settlements/NavigationTabLinks.scss"

class NavigationTabLinksForTransactions extends Component {
    
    generateNavLinks(){
        let urlArray= WebCache.isUserUYU() ? [
            {to: '/sales/transactions', icon: <TransactionReportSVG className="tab-icon" />, label: 'allTransactions'},
            {to: '/sales/pendingOrders', icon: <PendingOrdersSVG className="tab-icon" />, label: 'pendingOrders'},
        ] : []

        if(!WebCache.isUserUYU() && WebCache.getAllWholesalerMerchants(false).length>0) // si contiene comercios asociados y es de argentina, estara disponible esta seccion
            urlArray.push({ to: '/sales/minTransactions', icon: <TransactionReportSVG className="tab-icon" />, label: 'minTransactions'})

        return urlArray;
    }

    render() {
        return (
            <NavigationTabLinks
                items= {this.generateNavLinks()}
            ></NavigationTabLinks> 
        )
    };
}

export default NavigationTabLinksForTransactions;
